/* __next_internal_client_entry_do_not_use__ RenderProductBasedCollectionRoute auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductBasedCollection } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/ProductBasedCollection";
import { Route } from "@faire/web-api--source/Route";
import { props as productBasedCollectionRouteProps } from "@faire/web-api--source/routes/product-based-collection/product_based_collection_token";
import React from "react";
export var RenderProductBasedCollectionRoute = function() {
    return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, productBasedCollectionRouteProps), {
        exact: true,
        render: function(param) {
            var match = param.match;
            if (!match.params.productBasedCollectionToken) {
                throw new Error("Missing productBasedCollectionToken");
            }
            return /*#__PURE__*/ _jsx(ProductBasedCollection, {
                token: match.params.productBasedCollectionToken
            }, match.params.productBasedCollectionToken);
        }
    }));
};
